module.exports = __webpack_public_path__ + "static/flags/KT-1c2e1c525200c176828afd7c9a5ec8bc.gif";